// @ts-nocheck
import {
    getInvoicesLoading,
    getIsLoadingInvoice,
} from "@store/Framework/Store/Store/Pages/InvoiceDetails/InvoiceDetailsSelectors";
import convertSelectorToHook from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";

export const useIsLoadingInvoice = convertSelectorToHook(getIsLoadingInvoice);
export const useInvoicesLoading = convertSelectorToHook(getInvoicesLoading);
